import { type IconName, iconNames } from '../components/icon/icon_names';

const iconNameSet = new Set<string>(iconNames);

export function isIconName(value: string): value is IconName {
  return iconNameSet.has(value);
}
